export default __webpack_public_path__ + "static/media/Glacial_Lakes.6dc5f8e4.webp";